export default () => {
  $.fn.animateNumbers = function(stop, separator, duration, ease) {
    return this.each(function() {
      const $this = $(this);
      const start = parseInt($(this).text().replace(/,/g, ""));
      const regex = /(\d)(?=(\d\d\d)+(?!\d))/g;
      separator = separator === undefined ? true : separator;

      $({ value: start }).animate({ value: stop },{
          duration: duration === undefined ? 1000 : duration,
          easing: ease === undefined ? "swing" : ease,
          step: function() {
            $this.text(Math.floor(this.value));
            if (separator) {
              $this.text($this.text().replace(regex, "$1,"));
            }
          }
        }
      );
    });
  };

  const titleElement = $(".js-live-counter");
  const actualValue = titleElement.data("count");
  const minStep = titleElement.data("min");
  const maxStep = titleElement.data("max");
  const numsArray = [minStep, maxStep];
  let animateWasPlayedFlag = false;

  const getRandomNumberBetween = (min, max) =>
    Math.floor(Math.random() * (max - min + 1) + min);

  const getAverageNumber = arr =>
    Math.round(arr.reduce((a, b) => a + b) / arr.length);

  const getValueForNow = () => {
    const today = new Date();
    const fullHours = today.getHours();
    const fullMinutes = today.getMinutes();
    const fullSeconds = today.getSeconds();

    const totalSecondsFromMidnight =
      fullHours * 3600 + fullMinutes * 60 + fullSeconds;

    const valueNow =
      totalSecondsFromMidnight * getAverageNumber(numsArray) + actualValue;

    return valueNow;
  };

  const inView = element => {
    const win = $(window);
    const obj = element;
    const scrollPosition = win.scrollTop();
    const visibleArea = win.scrollTop() + win.height();
    const objEndPos = obj.offset().top;

    return visibleArea >= objEndPos && scrollPosition <= objEndPos;
  };

  const updateCounter = () => {
    let countUp = getValueForNow();
    countUp += getRandomNumberBetween(minStep, maxStep);

    titleElement.animateNumbers(countUp, true, 1000);
    setTimeout(updateCounter, 1000);
  };

  const initCounter = () => {
    if (titleElement.length && !animateWasPlayedFlag && inView(titleElement)) {
      updateCounter();
      animateWasPlayedFlag = true;
    }
  }

  initCounter();

  window.addEventListener("scroll", () => {
    initCounter();
  });
};
